import React, {useEffect, useState} from "react";
import "react-phone-number-input/style.css";
import PhoneInput, {formatPhoneNumberIntl, isValidPhoneNumber} from "react-phone-number-input";
import {Information} from "assets/icons";

// E.164 without spaces — the format the API stores. Both sides of any
// comparison go through this, otherwise "+596 696 12 34 56" and
// "+596696123456" read as two different numbers.
export const normalisePhone = (input) =>
    input ? formatPhoneNumberIntl(`${input}`).replace(/\s+/g, '') : '';

/**
 * Receives a phone number and reports one back, both as a normalised string.
 *
 * It reports ONLY from onChange. It used to report whenever the number became
 * valid, which happens on mount as soon as a stored number is loaded: the
 * parent read that as a user edit and saved a number nobody had touched
 * (JBWEB-1173).
 */
const SelectPhone = ({phoneValue, setPhoneValue}) => {
  const [value, setValue] = useState('');

  useEffect(() => {
    if (phoneValue?.length > 0) {
      setValue(formatPhoneNumberIntl(phoneValue));
    }
  }, [phoneValue])

  const validPhone = isValidPhoneNumber(`${value}`);

  const handleChange = (nextValue) => {
    setValue(nextValue);
    // An incomplete number reports as empty rather than as a partial one, so
    // the parent never compares against half a number.
    setPhoneValue(isValidPhoneNumber(`${nextValue}`) ? normalisePhone(nextValue) : '');
  };

  return (
      <>
        <PhoneInput
            className="w-full h-10 pl-3 pr-8 text-base border rounded-lg"
            placeholder="Indiquer votre numéro"
            defaultCountry="FR"
            value={value}
            onChange={handleChange}
        />
        {
          !validPhone ? (
              <p className={value?.toString().length > 0 && !validPhone ? "text-yellow-500 flex flex-row gap-4 items-center" : "hidden"}>
                <span>
                  <Information wh={14} color={"#FF9600"}/>
                </span>
                Numéro invalide
              </p>
          ) : ''
        }
      </>
  );
};

export default SelectPhone;
